<template>
    <v-dialog v-model="showDialog" max-width="800" scrollable>
        <template v-slot:activator="{on}">
            <slot name="activator" :on="on"></slot>
        </template>
        <v-card>
            <v-card-title>Logs for {{sample.id}}</v-card-title>
            <v-card-actions>
            </v-card-actions>
            <v-card-text>
                <v-progress-linear v-if="loading"></v-progress-linear>
                <v-data-iterator
                        v-else
                        :items="logs"
                        sort-by="timestamp"
                        sort-desc
                >
                    <template v-slot:default="{items}">
                        <v-list >
                            <v-card v-for="log in items" :key="log.id" class="pa-0" outlined>
                                <v-card-actions>
                                    <div class="subtitle">{{log.type}} | {{log.class}} | {{findTypeClass(log, log.class)}} | {{log.user_name}}</div>
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                                <v-card-text class="pa-2">
                                    <v-row v-for="(diff, index) in log.diff" :key="index" no-gutters>
                                        <v-col class="pl-2">
                                            <code class="green--text text--lighten-1 font-weight-bold grey darken-4 elevation-0" v-if="diff.includes('+')">{{findType(diff)}}</code>
                                            <code class="orange--text text-darken-1 font-weight-bold grey darken-4 elevation-0" v-else>{{findType(diff)}}</code>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-card-actions class="pa-0 grey--text">
                                    <v-spacer></v-spacer>
                                    {{$moment.duration($moment(log.timestamp).diff($moment())).humanize(true)}}
                                    | {{$moment.utc(log.timestamp).local().format("YYYY-MM-DD h:mma")}}
                                    <v-spacer></v-spacer>
                                </v-card-actions>
                            </v-card>
                        </v-list>
                    </template>
                </v-data-iterator>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "logs",
        data: () => ({
            showDialog: false,
            loading: false,
            logs: null,
            loadedTypes: false,
            loadingTypes: false,
        }),
        props:{
            sample:{
                required: true,
            },
        },
        watch:{
          showDialog(v){
              if(v){
                  this.loadLogs();
              }
          }
        },
        methods:{
            async loadLogs(){
                this.loading = true;
                let uuid = await this.$firestore.collection('logs').where("uuid", "==", this.sample.uuid).get();
                let sampleUuid = await this.$firestore.collection('logs').where("sample_uuid", "==", this.sample.uuid).get();
                let firstSetLogs = uuid.docs.map(doc => {
                    let data = doc.data();
                    return {
                        id: doc.id,
                        ...data,
                    }
                });
                let secondSetLogs = sampleUuid.docs.map(doc => {
                    let data = doc.data();
                    return {
                        id: doc.id,
                        ...data,
                    }
                });
                let mergeLogs = [...firstSetLogs, ...secondSetLogs];
                mergeLogs.sort((a,b) => {
                    return this.$moment(b.timestamp) - this.$moment(a.timestamp)
                });
                this.logs = mergeLogs;
                this.loading = false;
            },
            findTypeClass(value, table){
                let valCheck = table === "SampleTest" ? value.sample_uuid + ' | ' +value.sample_test_type_uuid :
                    table === "ContainerItem" ? value.sample_uuid + ' | ' + value.container_uuid :
                        table === "SampleNote" ? value.sample_uuid :
                            value.uuid;

                let findLabType = this.$store.$db().model('sampleTypes').query().where(type => valCheck.includes(type.uuid)).first();
                let findCertType = this.$store.$db().model('sampleCertTypes').query().where(type => valCheck.includes(type.uuid)).first();
                let findContainerType =  this.$store.$db().model('containerTypes').query().where(type => valCheck.includes(type.uuid)).first();
                let findContainers =  this.$store.$db().model('containers').query().where(type => valCheck.includes(type.uuid)).first();
                let findSample =  this.$store.$db().model('samples').query().where(type => valCheck.includes(type.uuid)).first();
                let sampleTestTypes =  this.$store.$db().model('sampleTestTypes').query().where(type => valCheck.includes(type.uuid)).first();
                valCheck = findLabType ? valCheck.replace(findLabType.uuid,findLabType.name) : valCheck;
                valCheck = findCertType ? valCheck.replace(findCertType.uuid, findCertType.name) : valCheck;
                valCheck = findContainerType ? valCheck.replace(findContainerType.uuid, findContainerType.name) : valCheck;
                valCheck = findContainers ? valCheck.replace(findContainers.uuid, findContainers.name) : valCheck;
                valCheck = findSample ? valCheck.replace(findSample.uuid, findSample.id) : valCheck;
                valCheck = sampleTestTypes ? valCheck.replace(sampleTestTypes.uuid, sampleTestTypes.description) : valCheck;
                return valCheck
            },
            findType(value){
                let findLabType = this.$store.$db().model('sampleTypes').query().where(type => value.includes(type.uuid)).first();
                let findCertType = this.$store.$db().model('sampleCertTypes').query().where(type => value.includes(type.uuid)).first();
                let findContainerType =  this.$store.$db().model('containerTypes').query().where(type => value.includes(type.uuid)).first();
                let findContainers =  this.$store.$db().model('containers').query().where(type => value.includes(type.uuid)).first();
                let findSample =  this.$store.$db().model('samples').query().where(type => value.includes(type.uuid)).first();
                let sampleTestTypes =  this.$store.$db().model('sampleTestTypes').query().where(type => value.includes(type.uuid)).first();
                return findLabType ? value.replace(findLabType.uuid,findLabType.name) :
                            findCertType ? value.replace(findCertType.uuid, findCertType.name) :
                            findContainerType ? value.replace(findContainerType.uuid, findContainerType.name) :
                            findContainers ? value.replace(findContainers.uuid, findContainers.name):
                                findSample ? value.replace(findSample.uuid, findSample.id):
                                sampleTestTypes ? value.replace(sampleTestTypes.uuid, sampleTestTypes.description):
                            value;
            }
        }
    }
</script>

<style scoped>

</style>
